import React from 'react';
import { useSelector } from 'react-redux';
import { selectManagementByApp, selectUserOrgByApp } from '@rsos/sinatra';
import Users from './Users';

const UsersManagement = ({ handleAccessDeniedLink }) => {
  const sinatra = useSelector(state => state.sinatra);
  const { jurisdictions } = useSelector(state => state.psaps.currentPSAP);
  const { application } = sinatra.user.currentRole;
  const org = selectUserOrgByApp(sinatra, application);
  const orgID = org.id;
  const management = selectManagementByApp(sinatra, org.id, application);
  // management is populated asynchronously during app initialize(); default to
  // empty until it loads so a render before the data arrives can't crash.
  const allRoles = management?.roles?.records ?? [];
  const currentPSAPUsers = management?.users?.records ?? [];

  return (
    <Users
      orgID={orgID}
      allRoles={allRoles}
      currentPSAPUsers={currentPSAPUsers}
      jurisdictions={jurisdictions}
      application={application}
      handleAccessDeniedLink={handleAccessDeniedLink}
    />
  );
};

export default UsersManagement;
